import { useEffect, useState } from 'react';
import { GiPresent } from 'react-icons/gi';
import { BiCartAdd, BiDollar } from "react-icons/bi";
import { MdReviews } from "react-icons/md";
import { GrGroup, GrNotification } from "react-icons/gr";
import { ImCancelCircle } from "react-icons/im";
import "./styles.css";
import { useFetchData } from '../../../hooks/useFetchData';
import { formatArabicDate } from '../../../utils/dateformat';

// Random icon selection
const icons = [BiCartAdd, BiDollar, GiPresent, MdReviews, GrGroup, ImCancelCircle];

function Notifications() {
    // Fetch notifications data dynamically using the useFetchData hook
    const { data } = useFetchData("mandoub/notification");
    const [unseens, setUnseens] = useState([]);
    const [showUnseens, setShowUnseens] = useState(false); // State to toggle between all and unseen notifications

    useEffect(() => {
        if (data?.notifications) {
            setUnseens(data.notifications.filter((item) => !item.isSeen));
        }
    }, [data]);

    const iconStyles = {
        BiCartAdd: { bg: "--light-primary", color: "--primary" },
        BiDollar: { bg: "--purple-light", color: "--purple" },
        GiPresent: { bg: "--cyan-light", color: "--cyan" },
        MdReviews: { bg: "--pink-light", color: "--pink" },
        GrGroup: { bg: "--pending-light", color: "--pending" },
        ImCancelCircle: { bg: "--canceled-light", color: "--canceled" },
    };

    const handleToggleUnseen = () => {
        setShowUnseens(!showUnseens); // Toggle the view between all and unseen notifications
    };

    // Render notifications based on whether we're showing all or just unseen ones
    const notificationsToDisplay = showUnseens ? unseens : data?.notifications;

    return (
        <div className="df-c section-card !gap-8 w-3/5 mx-auto no">
            <div className="df notif-nav">
            <div
             onClick={()=>setShowUnseens(false)}
    className={`df flex1 cursor-pointer ${!showUnseens ? 'active-nav' : ''} bordered !px-3 !py-2 jc-c`}
>
    الكل <span className='count'>{data?.notifications?.length}</span>
</div>
<div
    className={`df cursor-pointer flex1 bordered !px-3 !py-2 jc-c ${showUnseens ? 'active-nav' : ''}`}
    onClick={()=>setShowUnseens(true)} // Toggle unseen notifications on click
>
    الجديدة <span className='count'>{unseens?.length}</span>
</div>

            </div>
            <div className="notification-body notif-height df-c g0">
                {notificationsToDisplay?.map((notif) => {
                    // Select a random icon from the icons array
                    const RandomIcon = icons[Math.floor(Math.random() * icons.length)];
                    const iconName = RandomIcon.name;

                    return (
                        <div
                            key={notif._id}
                            className={`notification w-full df ai-fs ${notif.isSeen ? "" : "unseen"}`}
                        >
                            <div
                                className="rounded-icon"
                                style={{
                                    backgroundColor: `var(${iconStyles[iconName]?.bg || '--default-light'})`,
                                    color: `var(${iconStyles[iconName]?.color || '--default'})`
                                }}
                            >
                                <GrNotification /> {/* Render the randomly selected icon */}
                            </div>
                            <div className="df-c w-full g0">
                                <div className="bold-1">رسالة من الإدارة:</div>
                                <div className="text mt-2" style={{"fontSize":"16px"}}>{notif.content}</div>
                                <div className="text mt-4 w-fit mr-auto">
                                    {formatArabicDate(notif.createdAt)}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default Notifications;